export type GA4StandardEvents =
  'form_start' | 'form_submit' | 'generate_lead' | 'select_content';

export type GA4EventParams = {
  form_id?: 'contact' | 'lead_magnet' | string;
  content_type?: 'faq' | 'cta' | 'general_interaction' | 'phone' | 'email';
  item_id?: string;
  placement?: string;
  event_data?: Record<string, any>;
};

export const trackEvent = (
  eventName: GA4StandardEvents,
  params?: GA4EventParams,
) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
    return;
  }

  if (window.dataLayer && Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: eventName,
      ...params,
    });
    return;
  }
};
